// extracted by mini-css-extract-plugin
export var container = "DescriptionWithImage-module--container--cb7ae";
export var content = "DescriptionWithImage-module--content--fbc16";
export var imageOnRight = "DescriptionWithImage-module--image-on-right--70d0b";
export var img = "DescriptionWithImage-module--img--f6fbb";